module.exports = __webpack_public_path__ + "static/media/button-Like.6f255f49.svg";